const SLICERJWTTOKEN = 'ykx-slicer-jwt-token'
const SLICERJWTUSER = 'ykx-slicer-user'
const MARKETJWTTOKEN = 'ykx-market-jwt-token'
const MARKETJWTUSER = 'ykx-market-user'
const initSlicerJwtToken = localStorage[SLICERJWTTOKEN]
const initSlicerUser = localStorage[SLICERJWTUSER] ? JSON.parse(localStorage[SLICERJWTUSER]) : null
const initMarketJwtToken = localStorage[MARKETJWTTOKEN]
const initMarketUser = localStorage[MARKETJWTUSER] ? JSON.parse(localStorage[MARKETJWTUSER]) : null

const plugin = store => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'auth/setToken':
        localStorage[SLICERJWTTOKEN] = mutation.payload
        break
      case 'auth/resetToken':
        localStorage.removeItem(SLICERJWTTOKEN)
        break
      case 'auth/setUser':
        localStorage[SLICERJWTUSER] = JSON.stringify(mutation.payload)
        break
      case 'auth/resetUser':
        localStorage.removeItem(SLICERJWTUSER)
        break
    }
  })
}

export default plugin
export { initSlicerJwtToken, initSlicerUser, initMarketJwtToken, initMarketUser }



// WEBPACK FOOTER //
// ./src/store/plugins/localStorage.js